export function Logo({ withWordmark = true, size = 36, wordmarkClassName = "text-[#121413]" }) {
  // Default horizontal lockup: icon-only mark + Manrope wordmark rendered as crisp text.
  // Callers can pass `withWordmark={false}` to render the full stacked-lockup image instead.
  return (
    <span className="inline-flex items-center gap-2" data-testid="brand-logo">
      <img
        src={withWordmark ? "/logo-icon.png" : "/logo.png"}
        alt="JobKnocker"
        height={size}
        className="object-contain shrink-0"
        style={{ height: size, width: "auto" }}
      />
      {withWordmark && (
        <span className={`font-display font-extrabold text-lg tracking-tight ${wordmarkClassName}`}>
          JobKnocker
        </span>
      )}
    </span>
  );
}
